"use client"

import { NavigationTabsList } from "@rarible_int/anaconda_ui_components"
import { HeaderContentReatom } from "../header-content.reatom"
import {
  CollectiblesLink,
  ExploreLink,
  GachaLink,
  MintLink,
  // SwapLink,
} from "../header-navigation-links"
import { SearchReatom } from "../search/search.reatom"
import { useScrollState } from "./scroll-aware-wrapper"

interface BrandHeaderContentProps {
  className?: string
  rewardsFeature: React.ReactNode
}

export function BrandHeaderContentReatom({
  className,
  rewardsFeature,
}: BrandHeaderContentProps) {
  const { isScrolled } = useScrollState()

  return (
    <HeaderContentReatom
      className={`${className || ""} brand-header transition-all duration-300 ${
        isScrolled
          ? "scrolled bg-background/95 backdrop-blur-[10px]"
          : "!bg-transparent !backdrop-blur-0"
      }`.trim()}
      disableBlur={true}
      hideBanner={true}
      rewardsFeature={rewardsFeature}
      navigation={
        <NavigationTabsList size="sm" className="hidden flex-nowrap md:flex">
          <ExploreLink />
          <MintLink />
          <GachaLink />
          <CollectiblesLink />
          {/* <SwapLink /> */}
        </NavigationTabsList>
      }
      customSearch={
        <SearchReatom className="w-full max-w-[400px] [&_[cmdk-input-wrapper]]:bg-black/10 [&_[cmdk-input-wrapper]]:backdrop-blur-sm" />
      }
    />
  )
}
